import { motion } from "framer-motion";
import { Reveal } from "../Reveal";
import { BRIEFS } from "../../lib/data";

const BriefRow = ({ item, index }) => (
  <motion.div
    data-testid={`brief-item-${item.num}`}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: index * 0.05 }}
    className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6 items-center border-t border-white/12 py-8 sm:py-9 hover:bg-white/[0.03] transition-colors duration-300 px-2"
  >
    <div className="md:col-span-2 flex items-center gap-4">
      <span className="font-display text-5xl sm:text-6xl text-neutral-700 group-hover:text-[#e62429] transition-colors duration-300">
        {item.num}
      </span>
    </div>
    <div className="md:col-span-3 order-first md:order-none">
      <div className="relative w-full max-w-[220px]">
        <img
          src={item.img}
          alt={item.title}
          loading="lazy"
          className="w-full h-auto object-contain drop-shadow-[0_6px_20px_rgba(0,0,0,0.4)] group-hover:scale-[1.06] transition-transform duration-500"
        />
      </div>
    </div>
    <div className="md:col-span-4">
      <h3 className="font-display uppercase text-3xl sm:text-4xl text-white leading-none">
        {item.title}
      </h3>
    </div>
    <div className="md:col-span-3">
      <p className="text-base text-neutral-400 leading-relaxed">
        {item.body}
      </p>
    </div>
  </motion.div>
);

export const Briefs = () => {
  return (
    <section
      id="briefs"
      data-testid="briefs-section"
      className="relative bg-[#0a0a0a] py-24 sm:py-36"
    >
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4 lg:sticky lg:top-28 self-start">
            <Reveal>
              <p className="flex items-center gap-3 text-xs font-bold uppercase tracking-[0.3em] text-[#e62429] mb-6">
                <span className="h-px w-10 bg-[#e62429]" /> The kind of briefs we receive
              </p>
              <h2 className="font-display uppercase text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.9]">
                Sometimes the brief is simple.{" "}
                <span className="text-[#e62429]">Sometimes it isn't.</span>
              </h2>
              <p className="mt-6 text-neutral-400 text-lg max-w-sm">
                Whatever the ask, we design it, run it, grow it and make it
                matter.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            {BRIEFS.map((item, i) => (
              <BriefRow key={item.num} item={item} index={i} />
            ))}
            <div className="border-t border-white/12" />
          </div>
        </div>
      </div>
    </section>
  );
};
